import loadable from '@utils/loadable';

import withMetatag from '../../../decorators/metadataDecorators/metatagsTitleDecorator';
import Preloader from '../../../components/Preloader';

const MainCorporate = loadable(
  () => import('../../../components/MainCorporate'),
  { fallback: <div style={{ height: '100vh' }}><Preloader loading /></div> },
);

const styles = {
  position: 'relative',
  maxWidth: 1920,
  background: 'transparent',
  margin: 'auto',
  zIndex: 10,
  width: '100%',
};
export const CorporateLayout = () => (
  <div style={styles}>
    <MainCorporate
      isChatBot={false}
    />
  </div>
);

export default withMetatag(CorporateLayout, 'financial-enterprise-solutions');
